import { render, staticRenderFns } from "./MozError.vue?vue&type=template&id=ae48b974&scoped=true&"
import script from "./MozError.vue?vue&type=script&lang=js&"
export * from "./MozError.vue?vue&type=script&lang=js&"
import style0 from "./MozError.vue?vue&type=style&index=0&id=ae48b974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae48b974",
  null
  
)

export default component.exports